import { ActionButton, PageContainer, PageTitle, Subtitle } from '@if/mui'
import { Box } from '@mui/material'
import { useTranslation } from 'react-i18next'

const NotFound = () => {
  const { t } = useTranslation()
  return (
    <PageContainer>
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        minHeight="70vh"
        sx={{ textAlign: 'center' }}
      >
        <PageTitle color="primary">{t('common.404NotFound')}</PageTitle>
        <Subtitle sx={{ marginBottom: 3 }}>{t('common.sorry')}</Subtitle>
        <ActionButton emphasis="principal" href="/">
          {t('common.goHome')}
        </ActionButton>
      </Box>
    </PageContainer>
  )
}

export default NotFound
